/***
 * Configuration for Technicians Routes
 *
 * Technician Routes
 * Absence Routes
 ***/

/* ----- Views ----- */

// Technician
import TechniciansIndex from "@/pages/Technicians/Technicians";
import TechnicianDetails from "@/pages/Technicians/TechnicianDetails";

// Absence
import AbsenceAdd from "@/pages/Technicians/Absences/AbsenceAdd";
import AbsenceEdit from "@/pages/Technicians/Absences/AbsenceEdit";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

const parentsList = {
    techniciansIndex: { label: 'Liste des techniciens', name: 'Technicians' },
    technicianDetails: {
        label: 'Détails d\'un technicien',
        name: 'Technicians',
        params: { name: 'idTechnician', model: 'User', column: 'full_name' },
    },
}

const technicianRoutes = [
    {
        path: 'technicians',
        name: 'Technicians',
        component: TechniciansIndex,
        meta: {
            route: {
                label: 'Liste des techniciens'
            }
        },
    },
    {
        path: 'technicians/:idTechnician',
        name: 'Technician Details',
        component: TechnicianDetails,
        meta: {
            route: {
                label: 'Détails d\'un technicien',
                params: { name: 'idTechnician', model: 'User', column: 'full_name' },
            },
            parents: generateParentsList(parentsList, ['techniciansIndex']),
        },
    },
]

const absenceRoutes = [
    {
        path: 'technicians/absences/create',
        name: 'Add Absence',
        component: AbsenceAdd,
        meta: {
            route: {
                label: 'Ajout d\'une absence'
            },
            parents: generateParentsList(parentsList, ['techniciansIndex']),
        },
    },
    {
        path: 'technicians/absences/:idAbsence/edit',
        name: 'Edit Absence',
        component: AbsenceEdit,
        meta: {
            route: {
                label: 'Modification d\'une absence'
            },
            parents: generateParentsList(parentsList, ['techniciansIndex']),
        },
    },
]

const routes = [...technicianRoutes, ...absenceRoutes]
export default routes